"use client";

import * as React from "react";
import { Listbox, ListboxOption } from "@/components/catalyst/listbox";

export function BookMeeting() {
  return (
    <Listbox
      className="w-full sm:w-max"
      name="meeting-duration"
      onChange={(value) => {
        if (value === "15min") {
          window.open("https://cal.com/karlkoch/15min", "_blank");
        } else if (value === "30min") {
          window.open("https://cal.com/karlkoch/30min", "_blank");
        }
      }}
      placeholder="Schedule a chat"
    >
      <ListboxOption color="teal" value="15min">
        Book 15m meeting
      </ListboxOption>
      <ListboxOption color="teal" value="30min">
        Book 30m meeting
      </ListboxOption>
    </Listbox>
  );
}
